import axios from 'axios'

import { reatailmediaApi as baseAPI } from '../api'

const baseURL = `${baseAPI}/place`

/**
 * Get all places
 */
export const listPlacesKey = 'listPlaces'
export const listPlacesService = (params?: RequestListPlacesParams) =>
  axios.get<ResponseListPlaces>(baseURL, { params })

/**
 * Get all tags
 */
export const listTagsKey = 'listTags'
export const listTagsService = (params?: RequestListTagsParams) =>
  axios.get<ResponseListTags>(`${baseURL}/tags`, { params })

/**
 * Get screens by tags
 */
export const listScreensByTagsKey = 'listScreensByTags'
export const listScreensByTagsService = (
  body?: RequestListScreensByTagsParams
) => axios.post<ListScreensByTagsResponse[]>(`${baseURL}/search`, body)
